import apiClient from './client'
import type { LoginResponse, RegisterResponse, User } from '../../types'

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const res = await apiClient.post<{ access_token: string; user: User }>('/auth/login', { email, password })
    return { token: res.data.access_token, user: res.data.user }
  },

  register: async (
    name: string,
    email: string,
    password: string,
    role: string,
    agreed_terms_policy: boolean,
    agreed_sms_email_policy: boolean,
    phone: string,
    recaptcha_token?: string | null,
    // Honeypot — left empty by real users; a bot that fills every field it
    // finds populates it, which the backend uses to silently no-op the
    // signup. See the hidden "website" field in SignUp.tsx.
    website?: string,
  ): Promise<RegisterResponse> => {
    const res = await apiClient.post<{ access_token: string; user: User }>('/auth/register', {
      name,
      email,
      password,
      role,
      agreed_terms_policy,
      agreed_sms_email_policy,
      phone,
      recaptcha_token,
      website,
    })
    return { token: res.data.access_token, user: res.data.user }
  },

  captchaConfig: async (): Promise<{ enabled: boolean; site_key: string }> => {
    const res = await apiClient.get<{ enabled: boolean; site_key: string }>('/auth/captcha-config')
    return res.data
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout')
  },

  me: async (): Promise<User> => {
    const res = await apiClient.get<User>('/auth/me')
    return res.data
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const res = await apiClient.post<{ message: string }>('/auth/forgot-password', { email })
    return res.data
  },

  submitApplication: async (data: FormData): Promise<{ message: string }> => {
    const res = await apiClient.post<{ message: string }>('/onboarding/apply', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return res.data
  },

  resetPassword: async (token: string, email: string, password: string): Promise<void> => {
    await apiClient.post('/auth/reset-password', { token, email, password })
  },

  setupPassword: async (token: string, email: string, password: string): Promise<void> => {
    await apiClient.post('/auth/setup-password', { token, email, password })
  },
}
